export default [
  {
    label: 'Nome Completo',
    field: 'nome',
    type: 'custom',
  },
  { label: 'Login', field: 'login' },
  { label: 'Último acesso', field: 'dataUltimoAcesso' },
]
